define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/image/_base",
	"csi/reflection",
	"csi/xml"
], function(declare, csi, _, Controller, image, reflection, xml) {

	return declare(Controller, {
		toWriter: function() {
			// summary: set current image to action label and at the same time removing any other
			// label pointing to this image if not the default
			var a = this.m_action;
			var id = a.idAttr;
			var obj = a.getImageValue(this.getNode());
			var labeledKey = this.actionValue;
			var numberedKey = this.widget.getCurrentImageKey();
			var oldKeyArray = this.widget.getCurrentImageLabels();
			var cn = this.m_writer.changeNode(this.m_urlNode);
			var currentKey = null;

			var removeLabels = function(key, val) {
				// Clear the selected label if present on any other images
				cn.removeAttributeKeys(id, xml.ATTR_REFMAP, [key]);
				if (key.length > 1) {
					key = _.difference(key, [labeledKey]);
					cn.changeAttributeKeys(id, xml.ATTR_REFMAP, csi.objectNew(key, val));
				}
			};

			var getAllLabels = function(obj) {
				// get all labels with out number keys
				var labelArray = [];
				_.each(obj, function(key, val) {
					if (isNaN(val)) {
						labelArray.push({key: key, val: val});
					}
				});
				return labelArray;
			};

			var checkLabelPresent = function(obj, numKey, curKey) {
				// checks if label is already assigned to any other images
				var labels = getAllLabels(obj);
				_.each(labels, function(val) {
					if (numKey != val.val && val.val == curKey) {
						removeLabels([val.val], val.key);
					}
				});
			};

			checkLabelPresent(obj, obj[numberedKey], labeledKey);

			if (oldKeyArray.length) {
				if (!_.contains(oldKeyArray, labeledKey)) {
					currentKey = oldKeyArray.concat(labeledKey);
				} else {
					currentKey = _.difference(oldKeyArray, [labeledKey]).join();
				}
			} else {
				currentKey = labeledKey;
			}

			if (xml.nodeAttributeHasExpression(this.getNode(), id)) {
				cn.disableAttributeExp(id);
			}

			if (labeledKey === false) {
				// un-label image
				cn.removeAttributeKeys(id, xml.ATTR_REFMAP, oldKeyArray);
			} else if (labeledKey) {
				// un-label image before re-labeling
				if (oldKeyArray.length) {
					cn.removeAttributeKeys(id, xml.ATTR_REFMAP, oldKeyArray);
				}

				// label image
				if (currentKey) {
					var currentKeyArr = currentKey.toString().split(",");
					var currObj = {};
					_.each(currentKeyArr, function(val) {
						_.extend(currObj, csi.objectNew(val, obj[numberedKey]));
					});
					cn.changeAttributeKeys(id, xml.ATTR_REFMAP, currObj);
				}
			} else {
				// set image as default
				cn.changeAttributeKeys(id, xml.ATTR_REFMAP, csi.objectNew(reflection.DEFAULT_IMAGE_LABEL, obj[numberedKey]));
			}
		},

		postProcessSuccess: function() {
			// summary: redraw view
			this.widget.redraw();
		}
	});
});